import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "../data/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className={`yv-nav ${scrolled ? "scrolled" : ""}`} data-testid="main-navbar">
      <Link to="/" className="yv-logo-link" data-testid="nav-logo">
        <img src="/yellow-logo.png" alt="Yellow Video Production" className="yv-logo-img" />
      </Link>

      <nav className="yv-nav-links hidden lg:flex items-center gap-7">
        {NAV.map((n) => (
          <NavLink
            key={n.path}
            to={n.path}
            className={({ isActive }) => (isActive ? "active" : "")}
            data-testid={`nav-link-${n.path.replace(/\//g, "") || "home"}`}
          >
            {n.label}
          </NavLink>
        ))}
      </nav>

      <div className="hidden lg:block">
        <Link to="/contact" className="yv-btn yv-btn-primary" data-testid="nav-cta-quote">
          Get a Quote
        </Link>
      </div>

      <button
        className="lg:hidden text-white p-2"
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
        data-testid="nav-mobile-toggle"
      >
        {open ? <X size={26} /> : <Menu size={26} />}
      </button>

      {open && (
        <div
          className="lg:hidden absolute top-full left-0 right-0 bg-[#0a0a0a]/97 backdrop-blur border-t border-white/5 py-6 px-6 flex flex-col gap-3"
          data-testid="nav-mobile-menu"
        >
          {NAV.map((n) => (
            <NavLink
              key={n.path}
              to={n.path}
              className={({ isActive }) =>
                `py-2 text-base ${isActive ? "text-[var(--yellow)]" : "text-white/85"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Link to="/contact" className="yv-btn yv-btn-primary mt-4 justify-center">
            Get a Quote
          </Link>
        </div>
      )}
    </header>
  );
}
